/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InvsysImportStatus = 'FINISHED' | 'IMPORTING' | 'NOT_IMPORTING' | 'WAITING' | '%future added value';
export type checkInstitutionImportStatusMutationVariables = {
  institution: number;
};
export type checkInstitutionImportStatusMutationResponse = {
  readonly invsysCheckInstitutionImportStatus: {
    readonly status: InvsysImportStatus;
  };
};
export type checkInstitutionImportStatusMutation = {
  readonly response: checkInstitutionImportStatusMutationResponse;
  readonly variables: checkInstitutionImportStatusMutationVariables;
};

/*
mutation checkInstitutionImportStatusMutation(
  $institution: Int!
) {
  invsysCheckInstitutionImportStatus(institution: $institution) {
    status
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'institution',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'institution',
            variableName: 'institution',
          },
        ],
        concreteType: 'InvsysCheckInstitutionImportStatusResponse',
        kind: 'LinkedField',
        name: 'invsysCheckInstitutionImportStatus',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'status',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'checkInstitutionImportStatusMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'checkInstitutionImportStatusMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'ee7fe87626b3be3bb91b3d9d23c8f609',
      id: null,
      metadata: {},
      name: 'checkInstitutionImportStatusMutation',
      operationKind: 'mutation',
      text: 'mutation checkInstitutionImportStatusMutation(\n  $institution: Int!\n) {\n  invsysCheckInstitutionImportStatus(institution: $institution) {\n    status\n  }\n}\n',
    },
  };
})();
(node as any).hash = '6198101cd15ef25a9e3284d8bee0e612';
export default node;
